import { useWindowSize } from 'hooks'
import React from 'react'
import { DesktopHeader } from './desktop'
import { useSigner } from './hooks/connect-signer'
import { MobileHeader } from './mobile'
import { getHeaderStorage } from './navigation/storage/index'

type HeaderProps = {
  clickControlReference: React.RefObject<HTMLDivElement>
}

export const Header: React.FC<HeaderProps> = ({ clickControlReference }) => {
  useSigner()
  const { isMobile, isTablet } = useWindowSize()
  const { portfolioReturns } = getHeaderStorage()
  return (
    <>
      {isMobile || isTablet ? (
        <MobileHeader
          portfolioReturns={portfolioReturns}
          clickControlReference={clickControlReference}
        />
      ) : (
        <DesktopHeader
          portfolioReturns={portfolioReturns}
          clickControlReference={clickControlReference}
        />
      )}
    </>
  )
}
